import { decryptAES, encryptAES, isSet } from '../utils/commonUtils';
import { CREATED, OK } from '../utils/constant';
import httpInstance from './config';


// GET METHOD
const GET = async (url) => {
	try {
	  const res = await httpInstance.get(url);
  
	  if (res.status === 200) {
		const resData = res.data;
  
		if (resData.code === 200) {
		  return {
			...resData,
			data: decryptAES(resData.data),
		  };
		} else {
		  return resData; // Return even if code !== 200, so caller can handle it
		}
	  }
  
	  return res; // Return raw response if status !== 200
	} catch (error) {
	  // Handle known structure
	  if (error.response && error.response.data) {
		const resData = error.response.data;
  
		if (resData.code && resData.data) {
		  return {
			...resData,
			data: decryptAES(resData.data),
		  };
		} else {
		  return resData; // Return whatever the backend sent
		}
	  }
  
	  // Log and throw unknown errors
	  console.error("HTTP GET error:", error);
	  throw error;
	}
  };

const POST = async (url, body, header) => {
	// console.log('header',header);
	return  httpInstance.post(url, encryptAES(body), {
	  headers: header
	}).then((res)=>{
		if(res.status && res.data){
			const resData = res.data;
			if(resData.code===OK || resData.code===CREATED){
				return {
					...resData,
					data:decryptAES(resData.data)
				};
				
			}
		}
	}).catch(error => {
		// Interceptor rejects with axios `response` (status + data), not the raw Error.
		if (error?.data) {
			const resData = error.data;
			if (resData?.code !== undefined && resData?.data) {
				return {
					...resData,
					data: decryptAES(resData.data),
				};
			}
			// e.g. { code: 500, message: '...' } without data — let caller read message
			if (resData?.code !== undefined || resData?.message !== undefined) {
				return resData;
			}
		}
		// Legacy: unmatched errors resolve undefined (callers already guard response?.code)
	  });
}



const isSuccessHttpStatus = (status) => status >= 200 && status < 300;

const POSTwithoutAES = (url, body, header) => {
	// console.log('header',header);
	// For FormData (file uploads), omit Content-Type so axios sets multipart boundary automatically.
	const headers = (typeof FormData !== 'undefined' && body instanceof FormData)
		? { ...header, 'Content-Type': undefined }
		: header;
	let response = httpInstance.post(url, body, {
	  headers
	}).then((res)=>{
		if(isSuccessHttpStatus(res.status)){
			const resData = res.data;
			if((resData.code===OK || resData.code===CREATED)){
				return resData;
				
			}
		}
	}).catch(error => {
		// console.log('error',error);
		if(error.status){
              const resData = error.data;
              if(resData.code && resData.data){
                  return resData;
              }
        }
	  });
	return response;
}

const PUT = (url, body, header) => {
	let response = httpInstance.put(url, encryptAES(body), {
		headers: header
	  }).then((res)=>{
		  if(res.status===200){
			  const resData = res.data;
			  if((resData.code===OK || resData.code===CREATED)){
				  return {
					  ...resData,
					  data:decryptAES(resData.data)
				  };
				  
			  }
		  }
	  }).catch(error => {
		//   console.log('error',error);
		  if(error.status){
				const resData = error.data;
				if(resData.code && resData.data){
					return {
					  ...resData,
					  data:decryptAES(resData.data)
				  };;
				}
		  }
		});
	  return response;
}


const DELETE = (url,body={}) => {
	let response =  httpInstance.delete(url,{ data: body })
	.then((res)=>{
		if(res.status===200){
			const resData = res.data;
			if(isSet(resData) && (resData.code===OK || resData.code===CREATED)){
				return {
					...resData,
					data:decryptAES(resData.data)
				};
				
			}else{
				return null;
			}
		}
	}).catch(error => {
		console.log('error',error);
		if(error.status){
			  const resData = error.data;
			  if(resData.code && resData.data){
				  return {
					...resData,
					data:decryptAES(resData.data)
				};;
			  }
		}
	  });
	  return response;
}
const apiMethods = { GET, PUT, POST, DELETE, POSTwithoutAES };

export default apiMethods;
